(() => {
  // Product pages only
  if (!location.pathname.includes("/products/")) return;

  let productData = null;

  const getHandle = () => {
    const parts = location.pathname.split("/products/");
    return parts[1] ? parts[1].split("/")[0] : null;
  };

  const loadProductJson = async () => {
    const handle = getHandle();
    if (!handle) return null;

    const res = await fetch(`/products/${handle}.js`, { credentials: "same-origin" });
    if (!res.ok) return null;

    return await res.json();
  };

  // Robust: try selected swatches first, then fallback to native checked radios,
  // then fallback to hidden variant select -> map to variant options.
  const getSelectedOptionValues = () => {
    const expectedCount = productData?.options?.length || 3;

    // 1) Swatches (.block-swatch.is-selected) sorted by data-option-index
    const swatches = [...document.querySelectorAll(".block-swatch.is-selected")];

    const swatchValues = swatches
      .map((btn) => ({
        idx: Number(btn.getAttribute("data-option-index")),
        val:
          btn.getAttribute("data-option-value") ||
          btn.dataset.optionValue ||
          btn.textContent?.trim(),
      }))
      .filter((x) => x.val && !Number.isNaN(x.idx))
      .sort((a, b) => a.idx - b.idx)
      .map((x) => String(x.val).trim());

    if (swatchValues.length === expectedCount) return swatchValues;

    // 2) Prestige native radios
    const radioValues = [...document.querySelectorAll("input[data-option-position]:checked")]
      .map((el) => ({
        pos: Number(el.getAttribute("data-option-position")),
        val: el.value,
      }))
      .filter((x) => x.val && !Number.isNaN(x.pos))
      .sort((a, b) => a.pos - b.pos)
      .map((x) => String(x.val).trim());

    if (radioValues.length === expectedCount) return radioValues;

    // 3) Hidden variant select (if theme updates it)
    const variantSelect =
      document.querySelector('select[name="id"][id*="variant-select"]') ||
      document.querySelector('select[name="id"]');

    if (variantSelect?.value && productData?.variants?.length) {
      const v = productData.variants.find(
        (vv) => String(vv.id) === String(variantSelect.value)
      );
      if (v?.options?.length === expectedCount) {
        return v.options.map((o) => String(o).trim());
      }
    }

    return null;
  };

  const findMatchingVariantId = (options) => {
    if (!productData?.variants?.length || !options?.length) return null;

    // Exact match first
    let match = productData.variants.find((v) => {
      if (!v.options || v.options.length !== options.length) return false;
      return v.options.every(
        (opt, idx) => String(opt).trim() === String(options[idx]).trim()
      );
    });

    if (match) return String(match.id);

    // Fallback: normalize spacing/case in case swatch labels differ slightly
    const norm = (s) =>
      String(s)
        .trim()
        .replace(/\s+/g, " ")
        .toUpperCase();

    match = productData.variants.find((v) => {
      if (!v.options || v.options.length !== options.length) return false;
      return v.options.every((opt, idx) => norm(opt) === norm(options[idx]));
    });

    return match ? String(match.id) : null;
  };

  const setFormVariantId = (form, variantId) => {
    if (!form || !variantId) return;

    const idField =
      form.querySelector('input[name="id"]') ||
      form.querySelector('select[name="id"]');

    if (!idField) return;

    idField.disabled = false;
    idField.value = variantId;

    // Some theme code listens for this
    idField.dispatchEvent(new Event("change", { bubbles: true }));
  };

  const computeVariantId = () => {
    const selected = getSelectedOptionValues();
    if (!selected) return null;
    return findMatchingVariantId(selected);
  };

  window.addEventListener("DOMContentLoaded", async () => {
    console.log("[saddle-variant-fix] loaded", location.pathname);

    productData = await loadProductJson();

    if (!productData) {
      console.warn("[saddle-variant-fix] Could not load product JSON");
      return;
    }

    console.log("[saddle-variant-fix] options:", productData.options);
    console.log("[saddle-variant-fix] variants:", productData.variants?.length);

    // -----------------------------------------------------------
    // FIX: Simple products (1 variant, no real options like "bits")
    // Just ensure the form has the correct default variant ID and
    // the input is not disabled. Then bail out early so none of
    // the swatch/option matching logic interferes.
    // -----------------------------------------------------------
   if (productData.variants.length === 1) {
  const defaultId = String(productData.variants[0].id);

  document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
    const idField = form.querySelector('input[name="id"]');
    if (idField) {
      idField.value = defaultId;
      idField.disabled = false;
      // NOTE: intentionally NOT dispatching a change event here
      // to avoid triggering theme re-renders with mismatched data
    }
  });

  console.log("[saddle-variant-fix] simple product — set default variant:", defaultId);
  return;
}
  });

  // Force correct id right before submit to /cart/add
  document.addEventListener(
    "submit",
    (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.getAttribute("action")?.includes("/cart/add")) return;

      // Skip for simple products — already handled above
      if (productData?.variants?.length === 1) {
        const idField = form.querySelector('input[name="id"]');
        if (idField) {
          idField.disabled = false;
          idField.value = String(productData.variants[0].id);
        }
        return;
      }

      const selected = getSelectedOptionValues();
      const variantId = computeVariantId();

      console.log("[saddle-variant-fix] selected options:", selected);
      console.log("[saddle-variant-fix] computed variant:", variantId);

      if (variantId) setFormVariantId(form, variantId);
    },
    true
  );

  // Optional: keep id synced as you click swatches (helps with DOM swaps)
  document.addEventListener(
    "click",
    (e) => {
      if (!e.target.closest(".block-swatch")) return;

      // Skip for simple products
      if (productData?.variants?.length === 1) return;

      const variantId = computeVariantId();
      if (!variantId) return;

      document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
        setFormVariantId(form, variantId);
      });
    },
    true
  );
})();